<template>
  <div class="animated fadeIn mb-3">
    <b-row class="mt-4">
      <b-col lg="3">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          v-model="IsRotationView"
          name="radiosBtn"
        >
          <b-form-radio class="mx-0 mediumStandardizedRadioWidth" :value="false"
            >View All</b-form-radio
          >
          <b-form-radio class="mx-0 mediumStandardizedRadioWidth" :value="true"
            >By Cluster</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col sm="6">
        <b-form-group class="not_muted">
          <CoolSelect
            :disabled="!IsRotationView"
            v-model="current_rotation"
            placeholder="Select Cluster"
            theme="bootstrap"
            tooltip="Rotation"
            :items="current_seminar.Territory.Rotations"
            item-text="RotationName"
            item-value="RotationID"
            id="RotationID"
          >
            <template slot="input-before">
              <b-input-group-prepend>
                <b-input-group-text class="standardizedWidth not_muted"
                  >Cluster</b-input-group-text
                >
              </b-input-group-prepend>
            </template>
          </CoolSelect>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-button size="md" variant="outline-primary" @click="select_all">
          <!-- <i class="fa fa-close"></i> -->
          Select All
        </b-button>
        <b-button
          class="ml-2"
          size="md"
          variant="outline-primary"
          @click="deselect_all"
        >
          <!-- <i class="fa fa-close"></i> -->
          Clear All
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="12">
        <!-- <ul id="example-1">
          <li v-for="zip in zip.current_territory_zips" :key="zip.ZipCode">{{ zip.ZipCode }}</li>
        </ul>-->
        <ZipRow
          v-for="zip in current_zips"
          :key="componentKey(zip.ZipCode)"
          :seminar_object="current_seminar"
          :zip_object="zip"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ZipRow from "@/components/CustomSubComponents/ZipRow.vue";
import { CoolSelect } from "vue-cool-select";

export default {
  name: "ZipEditor",
  props: {
    seminar_object: { type: Object }
  },
  components: { CoolSelect, ZipRow },
  data() {
    return {
      current_seminar: this.seminar_object,
      current_zips: [],
      IsRotationView: false,
      current_rotation: {},
      myIterator: 0
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"])
  },
  methods: {
    componentKey: function(code) {
      //console.log(code + "_" + this.myIterator);
      return code + "_" + this.myIterator;
    },
    async select_all() {
      //alert(this.$store.state.seminar.seminar_edit.Zips.length);
      for (const zip of this.current_zips) {
        var _operation = {
          SeminarID: this.current_seminar.SeminarID,
          ZipCode: zip.ZipCode,
          ValueToSet: true
        };
        if (this.$store.state.n_user.n_current_user.IsSU) {
          await this.$store.dispatch("zip/setZipStatus", _operation);
        } else {
          await this.$store.dispatch(
            "zip/setZipStatusWithConflictCheck",
            _operation
          );
        }
      }
      // this.current_zips.forEach(zip => {
      //   var _operation = {
      //     SeminarID: this.current_seminar.SeminarID,
      //     ZipCode: zip.ZipCode,
      //     ValueToSet: true
      //   };
      //   //console.log(_operation);
      //   this.$store.dispatch("zip/setZipStatusWithConflictCheck", _operation);
      //});
      await this.$store
        .dispatch("seminar/RefreshZips", this.current_seminar.SeminarID)
        .then(response => {
          this.$store.state.seminar.seminar_edit.Zips =
            response.data["RefreshZipsResult"];
        });
      //alert(this.$store.state.seminar.seminar_edit.Zips.length);
      this.myincrementer();
    },
    async deselect_all() {
      //alert(this.$store.state.seminar.seminar_edit.Zips.length);
      for (const zip of this.current_zips) {
        var _operation = {
          SeminarID: this.current_seminar.SeminarID,
          ZipCode: zip.ZipCode,
          ValueToSet: false
        };
        await this.$store.dispatch("zip/setZipStatus", _operation);
      }
      // this.current_zips.forEach(zip => {
      //   var _operation = {
      //     SeminarID: this.current_seminar.SeminarID,
      //     ZipCode: zip.ZipCode,
      //     ValueToSet: true
      //   };
      //   //console.log(_operation);
      //   this.$store.dispatch("zip/setZipStatusWithConflictCheck", _operation);
      //});
      await this.$store
        .dispatch("seminar/RefreshZips", this.current_seminar.SeminarID)
        .then(response => {
          this.$store.state.seminar.seminar_edit.Zips =
            response.data["RefreshZipsResult"];
        });
      //alert(this.$store.state.seminar.seminar_edit.Zips.length);
      this.myincrementer();
    },
    async myincrementer() {
      if (this.IsRotationView) {
        this.filterByRotation();
      } else {
        this.filterByTerritory();
      }
    },
    async filterByTerritory() {
      await this.$store
        .dispatch("zip/loadZipsInTerritory", this.current_seminar.SeminarID)
        .then(response => {
          this.current_zips = response.data["ZipsByTerritoryResult"];
        });
      this.myIterator++;
    },
    async filterByRotation() {
      await this.$store
        .dispatch("zip/loadZipsInRotation", {
          seminarID: this.current_seminar.SeminarID,
          rotationID: this.current_rotation
        })
        .then(response => {
          this.current_zips = response.data["ZipsByRotationResult"];
        });
      this.myIterator++;
    }
  },
  created() {
    this.$store
      .dispatch("zip/loadZipsInTerritory", this.current_seminar.SeminarID)
      .then(response => {
        this.current_zips = response.data["ZipsByTerritoryResult"];
      });
  },
  watch: {
    "$store.state.zip.current_territory_zips": function(newValue, oldValue) {},
    "$store.state.seminar.seminar_edit.TerritoryID": function() {
      this.$store
        .dispatch("zip/loadZipsInTerritory", this.current_seminar.SeminarID)
        .then(response => {
          this.current_zips = response.data["ZipsByTerritoryResult"];
        });
    },
    "$store.state.seminar.seminar_edit.SeminarID": function(newValue) {
      if (newValue > 0) {
        this.$store
          .dispatch("zip/loadZipsInTerritory", this.current_seminar.SeminarID)
          .then(response => {
            this.current_zips = response.data["ZipsByTerritoryResult"];
          });
      }
    },
    "$store.state.seminar.seminar_edit.Zips.length": function(newValue) {
      //alert(newValue);
      //this.myIterator++;
      // if (newValue > 0) {
      //   this.$store
      //     .dispatch("zip/loadZipsInTerritory", this.current_seminar.SeminarID)
      //     .then(response => {
      //       this.current_zips = response.data["ZipsByTerritoryResult"];
      //     });
      // }
    },
    current_seminar: function(newValue, oldValue) {},
    current_rotation: function(newValue, oldValue) {
      if (this.current_rotation) {
        this.filterByRotation();
      }
    },
    IsRotationView: function(newValue, oldValue) {
      if (newValue === false) {
        this.filterByTerritory();
      } else {
        if (this.current_rotation) {
          this.filterByRotation();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
